// components/ArticleContent.tsx
"use client";
import React, { useEffect, useState } from "react";
// import Link from 'next/link';
import Image from "next/image";
import SectionHeading from "@/components/SectionHeading/SectionHeading";
// import TrendingSectionRight from "@/components/Sections/TrendingSectionRight";
// import TrendingSectionLeft from "@/components/Sections/TrendingSectionLeft";
import Link from "next/link";
import { Section, SessionUser } from "@/types/common";
// import TrendingSectionLeft from "@/components/Sections/TrendingSectionLeft";
import { ArticleData } from "@/types/article.types";
import { ContentBlock } from "@/types/common";
import { Button } from "./ui/Button";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { File } from "lucide-react";
import BroForm from "./BroForm";
import DownloadComponent from "./DownloadComponent";
import { useAuth } from "@/context/AuthContext";
import { AdsSection } from "./Sections/AdsSection";
import GumletImage from "@/utils/GumletSrcSet";

interface ArticleContentProps {
  data: ArticleData;
  ads: Section[];
}

const ArticleContent: React.FC<ArticleContentProps> = ({ data, ads }) => {
  // const [sessionUser, setSessionUser] = useState<SessionUser | null>(null);
  const { sessionUser } = useAuth();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [brandArr, setBrandArr] = useState<string[]>([]);

  // const [broFormData] = useState(
  //   localStorage.getItem("broFormData")
  //     ? JSON.parse(localStorage.getItem("broFormData") as string)
  //     : {}
  // );
  useEffect(() => {
    const brandIds = localStorage.getItem("brand_ids") || "";
    setBrandArr(brandIds ? brandIds.split(",") : []);
  }, []);

  const paragraphStyles = `
    .article-content p > li {
      padding-left: 3rem;
      text-indent: -1.5rem;
      // display: list-item;
    }

    .article-content  a {
      color: #FF6B00;
    }

    .article-content  a:hover {
      text-decoration: underline;
    }

    .article-content ul {
    list-style-type: disc;
    padding-left: 3rem;
 
  }

  .article-content ol {
    list-style-type: decimal;
    padding-left: 3.5rem;
  
  }
    .article-content iframe{
      width: 100%;
    }

    .article-content h1 {
      font-size: 2em;
      font-weight: 600;
    }

    .article-content h2 {
      font-size: 1.5em;
      font-weight: 600;
    }

    .article-content h3 {
      font-size: 1.25em;
      font-weight: 600;
    }

    .article-content h4 {
      font-size: 1em;
      font-weight: 600;
    }

    .article-content h5 {
      font-size: 0.875em;
      font-weight: 600;
    }

    .article-content h6 {
      font-size: 0.75em;
      font-weight: 600;
    }
      .article-content strong,
.article-content b {
  font-weight: bold;
}

.article-content em,
.article-content i {
  font-style: italic;
}

.article-content u {
  text-decoration: underline;
}

.article-content s,
.article-content del {
  text-decoration: line-through;
}

.article-content mark {
  background-color: yellow;
  color: black;
}

.article-content small {
  font-size: 0.8em;
}

.article-content sub {
  vertical-align: sub;
  font-size: smaller;
}

.article-content sup {
  vertical-align: super;
  font-size: smaller;
}
  `;

  const renderElement = (section: ContentBlock, index: number) => {
    switch (section.type) {
      case "header":
        return (
          <h2
            key={section.id + "_" + index + "_" + index}
            className="font-semibold text-lg uppercase text-foreground mb-4 leading-relaxed"
            dangerouslySetInnerHTML={{ __html: section.content }}
          />
        );
      case "paragraph":
        const cleanedContent = section.content.replace(
          /style="([^"]*)"/gi,
          (match, styles) => {
            const cleanedStyles = styles
              .split(";")
              .filter(
                (style: string) => !style.trim().startsWith("font-family")
              )
              .join(";");
            return cleanedStyles ? `style="${cleanedStyles}"` : "";
          }
        );
        return (
          // <React.Fragment>
          <div className="article-content" key={section.id + "_" + index}>
            <style>{paragraphStyles}</style>
            <div
              // className="font-normal text-lg text-foreground mb-4 leading-relaxed !font-custom w-full max-w-full"
              className="text-foreground mb-4 leading-relaxed !font-custom break-words"
              dangerouslySetInnerHTML={{ __html: cleanedContent }}
            />
          </div>
          // </React.Fragment>
        );
      case "gallery":
        return (
          <div
            key={section.id + "_" + index}
            className="mb-4 grid grid-cols-5 gap-4 border-y border-gray-300 py-4"
          >
            {section.images?.map(
              (
                image: { media_url: string; media_alt: string },
                imgIndex: number
              ) => (
                <div
                  key={`${index}-${imgIndex}-${image?.media_url ?? ""}`}
                  className="aspect-square bg-blue-300 rounded-md overflow-hidden relative"
                >
                  <GumletImage
                    imageUrl={image?.media_url}
                    fallbackSrc="/assets/images/dummy.jpg"
                    alt={image.media_alt || ""}
                    fill
                    className="object-cover w-full h-auto"
                  />
                </div>
              )
            )}
          </div>
        );
      case "slider":
        return (
          <div key={section.id + "_" + index} className="mb-8">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              navigation
              pagination={{ clickable: true }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              spaceBetween={16}
              slidesPerView={1}
              className="w-full h-[300px] md:h-[400px] lg:h-[500px]"
            >
              {section.images?.map((image, slideIndex) => (
                <SwiperSlide key={`${index}-slide-${slideIndex}-${image?.media_url ?? ""}`}>
                  <div className="relative w-full h-full">
                    <GumletImage
                      imageUrl={image?.media_url}
                      fallbackSrc="/assets/images/dummy.jpg"
                      alt={image.media_alt || `Slide ${slideIndex + 1}`}
                      fill
                      className="object-cover rounded-md"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        );
      case "summary":
        return (
          <div
            key={section.id + "_" + index}
            className="mb-4 border-l-4 border-orange pl-4 italic text-lg text-gray-700  my-6 "
          >
            {section.content}
          </div>
        );
      case "embedded":
        return (
          <div
            key={section.id + "_" + index}
            className="mb-4 w-full max-w-full"
            style={{ overflow: "hidden" }}
          >
            <iframe
              srcDoc={section.embed || ""}
              title={`Embedded Content ${index}`}
              style={{
                width: "100%",
                border: "none",
                overflow: "hidden",
                display: "block",
              }}
              scrolling="no"
              ref={(el) => {
                if (el) {
                  const setHeight = () => {
                    try {
                      if (
                        el.contentWindow &&
                        el.contentDocument &&
                        el.contentDocument.body
                      ) {
                        el.style.height =
                          el.contentDocument.body.scrollHeight + "px";
                      }
                    } catch (error) {
                      console.error(error);
                      // cross-origin, fallback to fixed height
                      el.style.height = "400px";
                    }
                  };
                  el.onload = setHeight;
                  // In case content changes after load
                  setTimeout(setHeight, 500);
                }
              }}
            />
          </div>
        );
      case "question":
        return (
          <div
            key={section.id + "_" + index}
            className="mb-4 text-lg font-medium"
          >
            Q. {section.question}
          </div>
        );
      case "answer":
        return (
          <div
            key={section.id + "_" + index}
            className="mb-4 text-lg font-light ml-11"
          >
            {section.answer}
          </div>
        );
      case "question-answer":
        return (
          <div key={section.id + "_" + index}>
            <div className="mb-4 text-lg font-medium">
              Q. {section.question}
            </div>
            <div className="mb-4 text-lg font-light ml-11">
              {section.answer}
            </div>
          </div>
        );
      case "cta":
        return (
          section.href && (
            <Link href={section.href} key={section.id + "_" + index} prefetch={false}>
              <Button className="mb-4">{section.label}</Button>
            </Link>
          )
        );
      case "attachment":
        return (
          <div
            className="mb-4 border rounded-md p-8 flex items-center gap-4"
            key={section.id + "_" + index}
          >
            <File />
            {section.media_url && (
              <Link target="_self" href={section.media_url} prefetch={false}>
                {section.content}
              </Link>
            )}
          </div>
        );
      case "blurb":
        return (
          <div key={section.id + "_" + index} className="mb-4 text-lg">
            {section.content}
          </div>
        );
      case "blockQuote":
        return (
          <blockquote
            key={`blockQuote-${index}`}
            className="mb-4 text-2xl italic font-fraunces"
            dangerouslySetInnerHTML={{ __html: section.content }}
          />
        );
      case "fact":
        return (
          <div key={section.id + "_" + index} className="mb-4 text-lg">
            {section.content}
          </div>
        );
      case "also-read":
        return (
          section.slug && (
            <div className="mb-4 mt-6" key={section.id + "_" + index}>
              <SectionHeading
                title="also read"
                bgColor="bg-lightOrange"
                textColor="text-background"
                link=""
              />

              <Link href={section.slug} className="text-4xl font-medium" prefetch={false}>
                {section.title}
              </Link>
            </div>
          )
        );
    }
  };
  
  const renderAds = (index: number) => {
    let inF = -1;
    if (index === 2) {
      inF = 0;
    }
    return <>{ads.length > inF && <AdsSection data={ads[inF]} />}</>;
  };
  
  return (
    <div>
      <div className="">
        {data?.json_content?.map((section, index) => {
          const contentKey = `json-${data?.post_id ?? "p"}-${index}-${section.type ?? "t"}`;
          if (index === 2) {
            return (
              <React.Fragment key={contentKey}>
                {renderAds(index)}
                {renderElement(section, index)}
              </React.Fragment>
            );
          }
          return (
            <React.Fragment key={contentKey}>
              {renderElement(section, index)}
            </React.Fragment>
          );
        })}
        {/* Render ads at the end if article has less than 3 content blocks */}
        {/* {shouldRenderAdAtEnd && <AdsSection data={ads[0]} />} */}

        {((data?.brand &&
          Object.keys(data.brand).length > 0 &&
          !isSubmitted &&
          data.brand.show_form) ||
          (data?.contentWall?.post_Wall?.code === "FORM" &&
            !isSubmitted &&
            !brandArr.includes(String(data?.brand?.brand_id)) &&
            !brandArr.includes(String(data?.contentWall?.fk_brand_id)))) && (
          <BroForm
            post_id={data?.post_id}
            brand_id={data?.brand?.brand_id || data?.contentWall?.fk_brand_id}
            setIsSubmitted={setIsSubmitted}
          />
        )}

        {data?.contentWall &&
          data?.contentWall?.post_Wall?.name === "research" &&
          Object.keys(data?.contentWall).length > 0 && (
            <DownloadComponent
              sessionUser={(sessionUser as SessionUser) || undefined}
              post_id={data?.post_id}
              // wall_id={data?.contentWall?.fk_wall_id}
              // post_Wall={data?.contentWall?.post_Wall}
              attachment={data?.contentWall?.attachment}
            />
          )}
      </div>

      {/* Topics section */}
      {data?.topics && data.topics.length > 0 && (
        <div className="pt-5">
          <SectionHeading
            title="Topics"
            bgColor="bg-lightOrange"
            textColor="text-white"
            link=""
          />
          <div className="flex items-center gap-5 flex-wrap mb-12">
            {data?.topics?.map((topic, index) => {
              return (
                <Link key={`topic-${topic.tag_id ?? topic.url}-${index}`} href={`/tag/${topic.url}`} prefetch={false}>
                  <p className="text-lg bg-zinc-200 hover:bg-orange hover:text-white px-3 py-1 rounded-md">
                    #{topic.name}
                  </p>
                </Link>
              );
            })}
          </div>
        </div>
      )}

      {(data?.authors ?? []).length > 0 && (
        <div itemProp="author" className="">
          {/* <h4 className="text-sm uppercase text-gray-500 mb-4">Author</h4> */}
          <SectionHeading
            title="Author"
            bgColor="bg-lightOrange"
            textColor="text-white"
            link=""
          />
          {/* {JSON.stringify(data?.authors, null, 2)} */}
          {data?.authors?.[0]?.bio && (
            <div className="flex items-center">
              <p
                className="font-normal text-lg text-foreground leading-relaxed"
                dangerouslySetInnerHTML={{
                  __html: data?.authors?.[0]?.bio ?? "",
                }}
              />
            </div>
          )}
          {data?.authors?.map((author, index) => (
            <div
              key={`author-${author.user_id ?? author.url}-${index}`}
              className={`flex items-center ${index > 0 ? "mt-6" : ""}`}
            >
              <div className="relative w-12 h-12 rounded-full overflow-hidden mr-4">
                <Link itemProp="url" href={`/author/${author?.url}`} prefetch={false}>
                  <GumletImage
                    imageUrl={author?.profile_image}
                    fallbackSrc="/assets/profile.svg"
                    alt={author?.name || ""}
                    fill
                    className="object-contain"
                  />
                </Link>
              </div>
              <div>
                <Link
                  itemProp="url"
                  href={`/author/${author?.url}`}
                  className=""
                  prefetch={false}
                >
                  <span itemProp="name">
                    {author?.name ||
                      `${author?.first_name || ""} ${
                        author?.last_name || ""
                      }` ||
                      "Unknown Author"}
                  </span>
                </Link>
                <div className="flex items-center text-sm text-gray-500">
                  {author?.social_link && author?.social_link !== "null" && (
                    <Link
                      href={author?.social_link || ""}
                      target="_self"
                      rel="noopener noreferrer"
                      className="relative h-3 w-3 mb-1"
                      prefetch={false}
                    >
                      <Image src="/assets/linkedIn.svg" alt="LinkedIn" fill />
                    </Link>
                  )}
                  {author?.email && author?.social_link && (
                    <span className="mx-2">|</span>
                  )}
                  {author?.email && (
                    <span className="text-gray-500 text-sm">
                      <span>{author?.email || ""}</span>
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ArticleContent;
